// extracted by mini-css-extract-plugin
module.exports = {"container":"NewMessagesIndicator_container__7lhC7","messages":"NewMessagesIndicator_messages__s6P5l"};